import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BellDot, ClipboardCheck, KeyRound, MessageCircleQuestion } from "lucide-react";
import { anonymousStatus } from "@/lib/publicApi";
import { EmergencyBar } from "./SaudeLayout";

export default function ContactHub() {
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    let alive = true;
    anonymousStatus().then((data) => {
      if (alive && data) setUnread(data.unread_count || 0);
    });
    return () => {
      alive = false;
    };
  }, []);

  const options = [
    {
      to: "/saude/fale-com-a-erimus/avaliacao",
      icon: ClipboardCheck,
      title: "Solicitar uma avaliação",
      description: "Fluxo identificado: precisamos do seu nome e telefone para entrar em contato.",
      testId: "contact-option-evaluation",
    },
    {
      to: "/saude/fale-com-a-erimus/pergunta",
      icon: MessageCircleQuestion,
      title: "Enviar uma pergunta anônima",
      description: "Sem nome, CPF, e-mail ou telefone. Você recebe uma chave de acesso para ver a resposta.",
      testId: "contact-option-question",
    },
    {
      to: "/saude/fale-com-a-erimus/consultar",
      icon: KeyRound,
      title: "Consultar resposta",
      description: "Use a chave de acesso que você guardou para ler a resposta e responder.",
      testId: "contact-option-lookup",
    },
  ];

  return (
    <div data-testid="saude-contact-page" className="space-y-6">
      <div>
        <p className="er-label">Fale com a Erimus</p>
        <h1 className="mt-3 font-display text-3xl font-medium tracking-tight text-ink-900">Como podemos ajudar?</h1>
        <p className="mt-3 text-sm leading-relaxed text-ink-600">
          Escolha o canal que faz mais sentido para você. Nenhum deles atende emergências.
        </p>
      </div>

      {unread > 0 ? (
        <Link
          to="/saude/fale-com-a-erimus/consultar"
          data-testid="anonymous-answer-badge"
          className="flex items-center gap-3 rounded-2xl border border-sage-600/40 bg-sage-50 px-4 py-3 text-sm text-sage-700 transition-colors hover:bg-sage-100"
        >
          <BellDot size={18} className="shrink-0" />
          <span>
            <strong className="font-medium">Resposta disponível</strong>
            <span className="block text-xs text-ink-500">
              Sua pergunta anônima tem resposta nova. Toque para abrir com a chave guardada.
            </span>
          </span>
        </Link>
      ) : null}

      <div className="space-y-3">
        {options.map((option) => (
          <Link key={option.to} to={option.to} data-testid={option.testId} className="er-card flex items-start gap-3">
            <option.icon size={20} className="mt-1 shrink-0 text-sage-600" />
            <span>
              <span className="block font-display text-base font-medium text-ink-900">{option.title}</span>
              <span className="mt-1 block text-sm text-ink-500">{option.description}</span>
            </span>
          </Link>
        ))}
      </div>
      <EmergencyBar />
    </div>
  );
}
